import axiosPost from "../axiosPost";

export const hotelDel = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFHotelDel",
        params: {
            SFHotelId: params?.SFHotelId
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
